import Errors from './Errors';

class Form {
  constructor(data, clear) {
    this.originalData = data;
    this.loading = false;
    for (let field in data) {
      this[field] = data[field];
    }
    this.errors = new Errors();
    this.clear = clear;
  }

  data() {
    let formData = new FormData();
    for (let field in this.originalData) {
      if (this[field] !== null && Array.isArray(this[field])) {
        this[field].forEach(item => {
          formData.append(field + '[]', item);
        });
      }
      else if (field === 'fileUpload') {
        const fileUpload = this[field];
        for (let fileGroup in fileUpload) {
          fileUpload[fileGroup].files.forEach(function(file) {
            formData.append(fileGroup + '[]', file);
          });
          fileUpload[fileGroup].filesNames.forEach(function(name) {
            formData.append(fileGroup + 'Names[]', name);
          });
          fileUpload[fileGroup].thumbsOrder.forEach(function(thumbs) {
            formData.append(fileGroup + 'ThumbsOrder[]', thumbs.id);
          });
          formData.append(fileGroup + 'ThumbsNames', JSON.stringify(fileUpload[fileGroup].thumbsNames));
        }
      }
      else {
        formData.append(field, this[field]);
      }
    }
    return formData;
  }

  reset() {
    for (let field in this.originalData) {
      this[field] = '';
    }
    this.errors.clear();
  }

  post(url) {
    return this.submit('post', url);
  }

  submit(requestType, url) {
    this.loading = true;
    return new Promise((resolve, reject) => {
      axios[requestType](url, this.data())
          .then(response => {
            this.onSuccess(response.data);
            resolve(response.data);
          })
          .catch(error => {
            this.onFail(error.response.data);
            reject(error.response.data);
          })
          .then(() => {
            this.loading = false;
          });
    });
  }

  onSuccess(data) {
    if (this.clear) {
      this.reset();
    } else {
      this.errors.clear();
    }
    if (this.originalData.hasOwnProperty('fileUpload') && data.hasOwnProperty('thumbs')) {
      for (let field in this.originalData.fileUpload) {
        if (data.thumbs.hasOwnProperty(field)) {
          Vue.set(this.fileUpload[field], 'files', []);
          Vue.set(this.fileUpload[field], 'filesNames', []);
          Vue.set(this.fileUpload[field], 'thumbsNames', {});
          Vue.set(this.fileUpload[field], 'thumbsOrder', data.thumbs[field]);
          for (let thumb of data.thumbs[field]) {
            Vue.set(this.fileUpload[field].thumbsNames, thumb.id, thumb.alt);
          }
        }
      }
    }
  }

  onFail(errors) {
    this.errors.record(errors.errors);
  }
}

export default Form;


// WEBPACK FOOTER //
// ./resources/js/core/Form.js